import React, { useState, useEffect } from "react";
import {
  Nav,
  Button,
  Offcanvas,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetForm } from "../../../features/formData/formSlice";
import {
  FaUserCircle,
  FaPenFancy,
  FaBuilding,
  FaBullhorn,
  FaBars,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";

import "./TabMenu.css";

const TabMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const loggedInUser = useSelector((state) => state.auth.user);
  const id = loggedInUser?.id;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showSidebar, setShowSidebar] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const tabItems = [
    { label: "My Space", path: "/dashboard/myspace", icon: <FaUserCircle /> },
    { label: "Post", path: "/dashboard/PostDashboard", icon: <FaPenFancy /> },
    {
      label: "Property",
      path: "/dashboard/PropertyDashboard",
      icon: <FaBuilding />,
      onClick: "resetForm",
    },
    {
      label: "Promotion",
      path: "/dashboard/PromotionDashboard",
      icon: <FaBullhorn />,
    },
  ];

  const handleTabClick = (item, idx) => {
    if (item.subMenu) {
      setOpenSubMenu(openSubMenu === idx ? null : idx);
      return;
    }
    if (item.onClick === "resetForm") dispatch(resetForm());
    navigate(item.path);
    if (isMobile) setShowSidebar(false);
  };

  const handleSubMenuClick = (sub) => {
    navigate(sub.path);
    if (isMobile) setShowSidebar(false);
  };

  const renderSidebar = () => (
<nav className="sidebar-container-modern">
  <Nav className="flex-column w-100 px-3 py-3">

    {tabItems.map((item, idx) => {
      const isSubMenuActive = item.subMenu?.some(
        (sub) => location.pathname === sub.path
      );
      const isActive = item.path
        ? location.pathname === item.path
        : isSubMenuActive;

      const isSubMenuOpen = item.subMenu
        ? openSubMenu === idx || isSubMenuActive
        : false;

      return (
        <React.Fragment key={item.label}>

          {/* MAIN LINK */}
          <Nav.Item>
            <Nav.Link
              as={item.path ? Link : "button"}
              to={item.path || undefined}
              onClick={(e) => {
                if (!item.path) e.preventDefault();
                handleTabClick(item, idx);
              }}
              className={`sidebar-link-modern ${
                isActive ? "active" : ""
              }`}
            >
              <div className="sidebar-left">
                <span className="sidebar-icon-modern">{item.icon}</span>
                <span className="sidebar-label-modern">{item.label}</span>
              </div>

              {item.subMenu && (
                <span className={`sidebar-chevron-modern ${isSubMenuOpen ? "open" : ""}`}>
                  {isSubMenuOpen ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              )}
            </Nav.Link>
          </Nav.Item>

          {/* SUBMENU */}
          {item.subMenu && (
            <div
              className={`sidebar-submenu-modern ${
                isSubMenuOpen ? "open" : ""
              }`}
            >
              {item.subMenu.map((sub) => (
                <button
                  key={sub.label}
                  type="button"
                  className={`sidebar-sublink-modern ${
                    location.pathname === sub.path ? "active" : ""
                  }`}
                  onClick={() => handleSubMenuClick(sub)}
                >
                  <span className="sidebar-icon-sub">{sub.icon}</span>
                  <span>{sub.label}</span>
                </button>
              ))}
            </div>
          )}

        </React.Fragment>
      );
    })}

  </Nav>
</nav>

  );

  return (
    <>
      {/* Mobile toggle button */}
      {isMobile && (
        <div className="p-2">
          <Button onClick={() => setShowSidebar(true)} variant="light bg-white">
            <FaBars />
          </Button>
        </div>
      )}

      {/* Desktop sidebar */}
      {!isMobile && renderSidebar()}

      {/* Mobile Offcanvas */}
      {isMobile && (
        <Offcanvas show={showSidebar} onHide={() => setShowSidebar(false)}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Menu</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>{renderSidebar()}</Offcanvas.Body>
        </Offcanvas>
      )}
    </>
  );
};

export default TabMenu;
